// loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private showTimeout:any;
  private startTime:number|null = null;

  loading$ = this.loadingSubject.asObservable();

  private readonly debounceDelay = 200;
  private readonly minViisbleTime = 300;

  constructor() { }

  showLoader() { // wont show the loader if the loader only loads 200ms
    clearTimeout(this.showTimeout);
    this.showTimeout = setTimeout(() => {
      this.startTime = Date.now();
      this.loadingSubject.next(true);
    }, this.debounceDelay) 
  }

  hideLoader() { // will stay loading atleast for 300ms to have a smooth transitions
    clearTimeout(this.showTimeout);
    if(this.startTime){
      const elapsed = Date.now()- this.startTime;
      const remaining = this.minViisbleTime-elapsed;

      if(remaining>0){  
        setTimeout(()=> {
          this.loadingSubject.next(false);
          this.startTime = null;
        }, remaining);
        return;
      }
    }
    this.loadingSubject.next(false);
    this.startTime = null
  }


}